/**
 * Return a resized variant of a remote image URL when the CDN supports it.
 * Falls back to the original src for data URLs, blob URLs, and unknown hosts.
 *
 *   optimizeImg('https://images.unsplash.com/photo-xxx?w=1200', 400)
 *   → 'https://images.unsplash.com/photo-xxx?w=400&h=400&fit=crop&q=70&auto=format'
 */
export function optimizeImg(src, size = 400) {
  if (!src || typeof src !== 'string') return src;
  if (src.startsWith('data:') || src.startsWith('blob:')) return src;
  try {
    const u = new URL(src);
    // Unsplash — resize on their edge
    if (u.hostname.endsWith('images.unsplash.com')) {
      u.searchParams.set('w', String(size));
      u.searchParams.set('h', String(size));
      u.searchParams.set('fit', 'crop');
      u.searchParams.set('q', '70');
      u.searchParams.set('auto', 'format');
      return u.toString();
    }
    // Emergent Object Storage / other CDNs — leave untouched, they already deliver
    // reasonably-sized images from the admin uploads.
    return src;
  } catch {
    return src;
  }
}
